import React from "react";
import { Tag } from "../../../tag/tag";
import Tooltip from '@material-ui/core/Tooltip';

import { Card, CardBody, CardFooter, CardPoints, CardItem } from "./LoyaltyCard.styled";

export const LoyaltyCard = React.forwardRef((props, ref) => {

    const card = props.card;
    const selected = props.selected;

    return (
        <Card selected={selected} onClick={props.onClick} ref={ref}>
            <CardBody>
                <CardItem>
                    <span> Id cartela: </span>
                    <span> {card.id}</span>
                </CardItem>
                <CardItem>
                    <span> Data início: </span>
                    <span> {card.createdAt}</span>
                </CardItem>
                <CardItem>
                    <span> {card.date.type === 'expireIn' ? 'Data para expirar:' : 'Data para inativar:'} </span>
                    <Tooltip arrow title={card.date.type.includes('expire') ? `Data para expiração da fidelidade: ${card.date.date}`: ''}>
                        <span> {card.date.date}</span>
                    </Tooltip>
                </CardItem>
            </CardBody>
            <CardFooter>
                <CardPoints selected={selected}>{card.value} {card.value === 1 ? 'ponto' : 'pontos'} </CardPoints>
                <Tooltip arrow title={card.status.tooltip}>
                    <span>
                        <Tag type={card.status.status ? 'positive' : 'negative'} size={card.status.label.length > 12 ? 'small' : 'normal'}> {card.status.label} </Tag>
                    </span>
                </Tooltip>
            </CardFooter>

            <div className="wrapper">
                <div className="wave"></div>
            </div>
        </Card>
    )
});

